import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What is VoloTag?",
    a: "VoloTag is a small responsive object you attach to the things you love to lose. Call out for it and it answers back — turning 'where is it?' into a short conversation instead of a search.",
  },
  {
    q: "Is it just another Bluetooth tracker?",
    a: "No. Bluetooth trackers sit silently on a map and wait for you to swipe through an app. VoloTag is built around voice — you call it, it replies. It's designed to feel like a tiny companion, not a device.",
  },
  {
    q: "Do I need to open an app?",
    a: "The experience is built to feel as app-free as possible. The core moment is voice in, voice back — the way you'd call a pet or a family member.",
  },
  {
    q: "What can I attach it to?",
    a: "Keys, bags, wallets, remotes, luggage, backpacks — any everyday thing you'd rather talk to than hunt for.",
  },
  {
    q: "When will it launch?",
    a: "VoloTag is in its early stage. Joining the waitlist is the fastest way to hear about launch news, availability, and early access windows.",
  },
  {
    q: "How can I get early access?",
    a: "Join the waitlist with your email. Early access spots are offered to waitlist members first, before public availability.",
  },
  {
    q: "Will there be limited early batches?",
    a: "Early batches are likely to be limited as we roll out carefully. Waitlist members are prioritized.",
  },
];

const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-28 md:py-36 bg-[#FAFAFA]"
    >
      <div className="mx-auto max-w-4xl px-6">
        <div className="text-center">
          <p className="text-xs tracking-[0.2em] uppercase text-blue-600 font-medium">FAQ</p>
          <h2 className="mt-3 font-display text-4xl md:text-5xl font-semibold tracking-tight">
            Questions, answered.
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="mt-14 rounded-3xl bg-white border border-zinc-200 overflow-hidden divide-y divide-zinc-200"
        >
          {faqs.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} data-testid={`faq-${i}`} className="border-0">
              <AccordionTrigger className="px-7 py-6 text-left font-display text-base md:text-lg font-medium tracking-tight hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="px-7 pb-6 text-zinc-600 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
